// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"UserProfileForm_emailInput__3F7Lx","editLink":"UserProfileForm_editLink__1RLEf"};